import { LazyModule, LazyAction } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "InboxPlusUtil" */ './lazyIndex')
);
export let lazyClearInboxTabsSessionData = new LazyAction(
    lazyModule,
    m => m.clearInboxTabsSessionData
);

export {
    isInboxPlusEnabled,
    isInAnyInboxPlusExperiment,
    isInAnyInboxPlusTreatment,
    isInEasyOnFocusedExclusionExperiment,
    isInEasyOnFocusedInclusionExperiment,
} from './util/inboxPlusFlightUtil';
